import {
  ERROR_EVENT,
  errorEventAction,
  ErrorMessage,
  REMOVE_ERROR_EVENT,
  removeErrorEventAction,
  DIALOGUE_ERROR,
  dialogueErrorAction,
} from '../Actions';
import { ClientErrorsState } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { dialogueErrorBody } from 'sos-eservice-common/js/config/dialogueErrorBodies';
import { clientError } from 'sos-common/js/commonTypes/ClientError.types';

function addErrorToState(state: ClientErrorsState, payload: ErrorMessage<Error>) {
  const newState = { ...state };
  const { friendlyMessage, error, fieldName } = payload;
  newState[fieldName] = {
    error,
    errorMessage: friendlyMessage,
  } as clientError;
  return newState;
}

function addDialogueErrorToState(state: ClientErrorsState, payload: dialogueErrorBody) {
  const newState = { ...state };
  if (newState['dialogueErrorBodies']) {
    (newState['dialogueErrorBodies'] as dialogueErrorBody[]).push(payload);
  } else {
    newState['dialogueErrorBodies'] = [payload];
  }

  return newState;
}

function removeErrorFromState(state: ClientErrorsState, fieldName: string) {
  const newState = { ...state };
  // code smell: does it work with setting undefined?
  // delete keyword is a costly operation, and has an adverse affect on optimizing engines..
  delete newState[fieldName];
  return newState;
}

export function errors(
  state: ClientErrorsState = {},
  action: errorEventAction | removeErrorEventAction | dialogueErrorAction
) {
  if (action.type === ERROR_EVENT) {
    return addErrorToState(state, action.payload);
  } else if (action.type === REMOVE_ERROR_EVENT) {
    return removeErrorFromState(state, action.payload);
  } else if (action.type === DIALOGUE_ERROR) {
    return addDialogueErrorToState(state, action.payload);
  }
  return state;
}

export function dialogueErrors(state: any = {}, action: dialogueErrorAction) {}
